
import Vue from 'vue';
import QoalaTyped from '../../Icons/QoalaTyped.vue';
import NotificationIcon from '../../Icons/NotificationIcon.vue';
import { Padder } from '../Spacings';

/**
 * The Header of the Application with Notification.
 *
 * This template consist of:
 *
 * - Menu icon
 * - Logo
 * - Notification icon
 */
export default Vue.extend({
  name: 'AppBarEntry',
  components: {
    QoalaTyped,
    NotificationIcon,
    Padder
  },
  props: {
    /**
     * The flag / badge on the top-right of notification icon.
     */
    hasNotification: {
      type: Boolean,
      default: false
    },
    /**
     * The number of notification.
     */
    notificationCount: Number
  },
  methods: {
    handleMenuClick() {
      /**
       * Handle when user click the menu.
       * @event menu-click
       * @type {function}
       */
      this.$emit('menu-click');
    },
    handleNotificationClick() {
      /**
       * Handle when user click the notification icon.
       * @event notification-click
       * @type {function}
       */
      this.$emit('notification-click');
    }
  }
});
